import React, { useMemo } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { CharterCabinClass, CharterFlight, SeatSelectionState, Traveller } from '../charter.types';

import SeatRow from './SeatRow';

type FlightSeatMapProps = {
  flight: CharterFlight;
  seatSelections: SeatSelectionState;
  travellers: Array<Traveller>;
};

const CABIN_CLASS_LABELS: Record<CharterCabinClass, string> = {
  business: 'Business',
  lux_row: 'SkyLounge',
  premium_economy: 'Premium Economy',
  economy: 'Economy',
};

export default function FlightSeatMap({ flight, seatSelections, travellers }: FlightSeatMapProps): React.JSX.Element {
  const filteredRows = useMemo(() => {
    const cabin = flight.cabinClass;
    if (!cabin) {
      return flight.cabinLayout;
    }
    return flight.cabinLayout.filter((row) => row.cabin === cabin);
  }, [flight.cabinClass, flight.cabinLayout]);

  return (
    <Stack spacing={2} alignItems="center" sx={{ width: '100%' }}>
      {flight.cabinClass && (
        <Box sx={{ width: '100%', mb: 1 }}>
          <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: 600 }}>
            {CABIN_CLASS_LABELS[flight.cabinClass]}
          </Typography>
        </Box>
      )}
      <Stack spacing={1} alignItems="center" sx={{ width: '100%' }}>
        {filteredRows.map((row) => (
          <SeatRow
            key={`${flight.id}-${row.rowId}`}
            row={row}
            flightId={flight.id}
            seatSelections={seatSelections}
            travellers={travellers}
          />
        ))}
      </Stack>
    </Stack>
  );
}
